module.exports = __webpack_public_path__ + "13a7168bffa4dbd971d43798a645d289.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/images/warhammer.jpg
// module id = 544
// module chunks = 0